import { Box, Drawer, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import HtmlParser from "react-html-parser";
import { CustomLink } from "./link/Link";
import Text from "./text/Text";
import { Tag } from "./tag/Tag";
import { apply, moreDetails, remove } from "./messages";
import DialogBox from "./dialog/Dialog";
import { checkCircleCurved, couponCodeIconGrey } from "./images";

const CouponCode = ({
  appliedCoupon,
  setAppliedCoupon,
  isFromBrowser,
  couponCode,
  validateCoupon,
  setIsCouponListOpen,
  openCodeAppliedPopup,
  hasShownPopup,
  setHasShownPopup,
}) => {
  const [isCodeApplied, setIsCodeApplied] = useState(
    appliedCoupon?.id === couponCode.id
  );
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState(false);

  const isCodeEligible = couponCode.is_eligible;

  const handleApplyClick = async () => {
    if (isCodeEligible) {
      if (isCodeApplied) {
        setAppliedCoupon(null);
      } else {
        const isValid = await validateCoupon(couponCode);
        if (isValid) {
          setIsCouponListOpen(false);
          setAppliedCoupon(couponCode);
          if (!hasShownPopup) {
            openCodeAppliedPopup();
            setHasShownPopup(true);
          }
        }
      }
    }
  };

  useEffect(() => {
    setIsCodeApplied(appliedCoupon?.id === couponCode.id);
  }, [appliedCoupon]);

  return (
    <Box className="coupon-code" display="flex" margin="10px" gap={1}>
      <img
        src={isCodeApplied ? checkCircleCurved : couponCodeIconGrey}
        height={20}
        width={20}
      />
      <Box display="flex" flexDirection="column" gap={2} width="100%">
        <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="space-between"
          gap={3}
        >
          <Text font="semibold" color={isCodeEligible ? "#000" : "#848B9E"}>
            {couponCode?.user_description}{" "}
          </Text>
          <CustomLink
            color={
              isCodeEligible ? (isCodeApplied ? "error" : "primary") : "#848B9E"
            }
            style={{
              fontSize: "12px",
              fontWeight: "600",
              marginTop: "6px",
            }}
            onClick={handleApplyClick}
          >
            {isCodeApplied ? remove.toUpperCase() : apply.toUpperCase()}
          </CustomLink>
        </Box>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Tag
            sx={{
              height: "auto !important",
              maxWidth: "150px",
              wordBreak: "break-word",
              "& .MuiChip-label": {
                color: isCodeEligible
                  ? "#000 !important"
                  : "#848B9E !important",
                whiteSpace: "normal !important",
                textAlign: "left !important",
              },
            }}
            text={couponCode.name.toUpperCase()}
          />
          <CustomLink
            alignIcon="end"
            withIcon={<KeyboardArrowDownIcon />}
            color="primary"
            onClick={() => {
              setIsDetailsDrawerOpen(true);
            }}
            style={{
              fontSize: "12px",
              fontWeight: "600",
            }}
          >
            {moreDetails.toUpperCase()}
          </CustomLink>
        </Box>
      </Box>

      {isFromBrowser ? (
        <DialogBox
          isOpenModal={isDetailsDrawerOpen}
          setIsOpenModal={setIsDetailsDrawerOpen}
          showAppBar={true}
          directionToOpen="up"
          modalHeader={moreDetails}
          className="coupon-code-modal"
          PaperProps={{
            sx: {
              width: "400px",
              margin: "auto",
              ".MuiAppBar-root": {
                backgroundColor: "#F7FAFC",
              },
            },
          }}
          fullScreen={false}
          handleAction={() => setIsDetailsDrawerOpen(false)}
        >
          <Box margin="24px">{HtmlParser(couponCode?.terms_text)}</Box>
        </DialogBox>
      ) : (
        <Drawer
          anchor="bottom"
          open={isDetailsDrawerOpen}
          onClose={() => {
            setIsDetailsDrawerOpen(false);
          }}
          sx={{
            zIndex: 1300,
          }}
          PaperProps={{
            sx: {
              borderTopLeftRadius: "14px",
              borderTopRightRadius: "14px",
              margin: "auto",
            },
          }}
        >
          <Box className="apply-coupon-heading">
            <Text size={18} className="default-text" font="semibold">
              {moreDetails}
            </Text>
            <IconButton onClick={() => setIsDetailsDrawerOpen(false)}>
              <CloseIcon
                sx={{
                  color: "#848B9E",
                  height: "24px",
                  width: "24px",
                }}
              />
            </IconButton>
          </Box>
          <Box margin="0 16px">{HtmlParser(couponCode?.terms_text)}</Box>
        </Drawer>
      )}
    </Box>
  );
};

export default CouponCode;
